const getValorTipoConvenio = (tipoConsultaId, convenioAgendamentoTipo) => {
    const valorTipoConsulta = convenioAgendamentoTipo && convenioAgendamentoTipo.length > 0 && convenioAgendamentoTipo.find(item => {
        return item.agendamentoTipo.id === tipoConsultaId
    });

    return valorTipoConsulta?.valor || 0
}

export default getValorTipoConvenio